import React from 'react';
import { Dialog } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { formatFileSize } from '../../../utils/vacationReceiptFiles';
import {
    DELETE_CONFIRM_NO,
    DELETE_CONFIRM_YES,
    DELETE_MODAL_TITLE,
    DELETE_MODAL_WARNING,
    formatReference,
} from '../vacationReceipts.definitions';
import type { DeleteReceiptModalProps } from '../vacationReceipts.types';
export const DeleteReceiptModal: React.FC<DeleteReceiptModalProps> = ({
    receipt,
    onCancel,
    onConfirm,
}) => {
    if (!receipt) return null;

    return (
        <Dialog open onClose={onCancel} className="relative z-50">
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className="w-full max-w-md overflow-hidden rounded-xl bg-white shadow-xl">
                    <div className="flex gap-3 p-6">
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-100">
                            <ExclamationTriangleIcon
                                className="h-5 w-5 text-red-600"
                                aria-hidden="true"
                            />
                        </span>

                        <div className="min-w-0">
                            <Dialog.Title className="text-lg font-medium text-gray-900">
                                {DELETE_MODAL_TITLE}
                            </Dialog.Title>

                            <p className="mt-2 break-words text-sm font-medium text-gray-900">
                                {receipt.fileName}
                            </p>
                            <p className="text-xs text-gray-500">
                                {formatReference(
                                    receipt.referenceStartDate,
                                    receipt.referenceEndDate
                                )}
                                {` · ${formatFileSize(receipt.sizeBytes)}`}
                            </p>

                            <p className="mt-3 text-sm text-gray-500">{DELETE_MODAL_WARNING}</p>
                        </div>
                    </div>

                    <div className="flex justify-end gap-2 border-t border-gray-200 bg-gray-50 px-6 py-4">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                            {DELETE_CONFIRM_NO}
                        </button>
                        <button
                            type="button"
                            onClick={() => onConfirm(receipt)}
                            className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
                        >
                            {DELETE_CONFIRM_YES}
                        </button>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
};

export default DeleteReceiptModal;
